<template>
    <v-dialog v-model="dialog" width="800" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="role"
                                :rules="[formRules.required]"
                                label="Role"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                readonly
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="unit"
                                @update:model-value="clearFaculty()"
                                :rules="[formRules.required]"
                                label="Unit"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="unitData"
                                item-title="name"
                                item-value="value"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col v-if="unit == 'teaching'" cols="12">
                            <v-autocomplete
                                v-model="faculty"
                                :rules="[formRules.required]"
                                @update:model-value="changeValue()"
                                label="Faculty Name"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="facultyData"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col v-if="unit == 'non-teaching'" cols="12">
                            <v-text-field
                                v-model="faculty_name"
                                :rules="[formRules.required]"
                                label="Faculty Name"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    emits: ["refresh"],
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            user_id: null,
            rep_title_id: null,
            role: null,
            faculty_name: null,
            unit: null,
            rep_title: null,

            faculty: [],
            facultyData: [],

            unitData: [
                { name: 'Teaching', value: 'teaching' },
                { name: 'Non-Teaching', value: 'non-teaching' }
            ],
        }
    },
    methods: {
        initAddLeader(data){
            this.dialog = true
            this.dialog_title = 'RDE Unit Loading'
            this.dialog_sub_title = 'Add new rde unit loading'
            this.action = 'add'

            this.initFaculties()

            this.user_id = null
            this.rep_title_id = data.id
            this.role = 'Leader'
            this.rep_title = data
        },
        initAddMember(data){
            this.dialog = true
            this.dialog_title = 'RDE Unit Loading'
            this.dialog_sub_title = 'Add new rde unit loading'
            this.action = 'add'

            this.initFaculties()

            this.user_id = null
            this.rep_title_id = data.id
            this.role = 'Member'
            this.rep_title = data
        },
        initFaculties(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findAllWithProgram',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.facultyData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        changeValue() {
            if (this.faculty && this.faculty.id) {
                this.user_id = this.faculty.id;
                this.faculty_name = this.getItemTitle(this.faculty);
            } else {
                console.warn('Invalid faculty data. Cannot assign values.');
            }
        },
        clearFaculty(){
            if(this.unit == 'non-teaching'){
                this.faculty = []
                this.faculty_name = null
            }
            else if (this.unit == 'teaching'){
                this.faculty_name = null
                this.initFaculties()
            }
        },
        getItemTitle(item) {
            return `${item.fname} ${item.mname ? item.mname[0] + '.' :''} ${item.lname}${item.suffix ? ', ' + item.suffix : ''}` ;
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: null,
                    user_id: this.user_id,
                    rep_title_id: this.rep_title_id,
                    role: this.role,
                    faculty_name: this.faculty_name,
                    unit: this.unit,
                    rep_title: this.rep_title,
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/rep-unit-load', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('REP Unit Load successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>